// #608 / gate 675 D17, Session 79.22b.5.3 -- DID A LIST ARRIVE WHOLE?
//
// The database hands back at most 1,000 rows and cuts the rest with no error,
// so a list read on its own cannot tell "that is everything" from "that is
// where it stopped". Every bounded read that matters asks for its count
// alongside the rows ({ count: 'exact' }); a count larger than what arrived is
// the signal that the list was cut. A screen that sees it SAYS SO - a list
// notice, or "couldn't check" in place of a figure that would be missing some
// of what it counts - and never shows the part as if it were the whole.
//
// No count (a read that did not ask, or a failed read) is not a cut: the
// caller already handles an error, and guessing "cut" would hide good figures.
export function cutOff(result) {
  if (!result || result.count == null) return false;
  const arrived = Array.isArray(result.data) ? result.data.length : 0;
  return Number(result.count) > arrived;
}
